// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__nwOtX","title":"Header_title__2SAwc","side":"Header_side__3PUnP"};